import {
  activateConsumer,
  activeEffectWatcher,
  Consumer,
  deactivateConsumer,
  deactivateWatcher,
  isWatcherExist,
} from './deps';
import { ReactiveValue } from './reactive-value';
import { prefix } from '../../lib/logger';

const { error } = prefix('reactive-value');

export class Watcher implements Consumer {
  deps: Set<ReactiveValue<unknown>> = new Set();
  private _effect: () => void;
  private _active: boolean = true;

  constructor(effect: () => void, runImmediately: boolean = true) {
    this._effect = effect;
    if (runImmediately) this.run();
  }

  run() {
    if (!this._active) return;
    if (isWatcherExist(this)) {
      error('Circular dependencies detected');
      return;
    }

    this.cleanup();
    activateConsumer(this);
    activeEffectWatcher(this);
    try {
      this._effect();
    } finally {
      deactivateConsumer();
      deactivateWatcher();
    }
  }

  markDirty() {
    this.run();
  }

  cleanup() {
    this.deps.forEach((dep) => {
      dep.listeners.delete(this);
    });
    this.deps.clear();
  }

  dispose() {
    this._active = false;
    this.cleanup();
  }
}

export function watch(effect: () => void) {
  const watcher = new Watcher(effect);
  return () => watcher.dispose();
}

export function createWatcher(effect: () => void, runImmediately: boolean = true) {
  return new Watcher(effect, runImmediately);
}
